import React from 'react';

/**
 * ModalWrapper - Consistent modal overlay and box styling for all modals.
 * Usage: <ModalWrapper open={open} onClose={onClose}><div>...</div></ModalWrapper>
 */
export default function ModalWrapper({ open, onClose, children, zIndex = 40, minWidth = 340, maxWidth = 440 }) {
  if (!open) return null;
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: '#0008',
      zIndex,
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
      overflowY: 'auto',
      padding: '20px 0',
    }} onClick={onClose}>
      <div
        style={{
          background: '#fff',
          padding: 32,
          borderRadius: 18,
          minWidth,
          maxWidth,
          maxHeight: 'calc(100vh - 40px)',
          overflowY: 'auto',
          boxShadow: '0 8px 32px 0 rgba(60,60,100,0.18)',
          display: 'flex',
          flexDirection: 'column',
          gap: 18,
          alignItems: 'center',
          position: 'relative',
          margin: 'auto',
        }}
        onClick={e => e.stopPropagation()}
      >
        {children}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: 12,
            right: 16,
            background: 'none',
            border: 'none',
            fontSize: 22,
            color: '#888',
            cursor: 'pointer',
            fontWeight: 700,
          }}
          aria-label="Close modal"
        >×</button>
      </div>
    </div>
  );
}
